import * as kpisServices from '@/services/kpis.js'
import * as productsServices from '@/services/products.js'
import { assertArray } from '@/config/helpers.js'
import * as categoriesService from '@/services/categories.js'
import { apolloProvider } from '@/apollo-provider.js'
import { QUERY_GET_MEASURES } from '@/modules/produtos/gerenciamento-produtos/graphql/index.js'
import { getMeasureUnit } from '@/helpers/measureUnits'

export default {
  async totaisVendasProdutos({ state, commit }, filter) {
    const { data } = await kpisServices.totaisVendasProdutos(filter)
    commit('SET_OBJECT', { name: 'totaisVendasProdutos', data, state })
  },
  async totaisVendasProdutosTop({ state, commit }, filter) {
    const { data } = await kpisServices.totaisVendasProdutosTop(filter)
    commit('SET_OBJECT', { name: 'totaisVendasProdutosTop', data, state })
  },
  async produtosMaisVendidosTop({ state, commit }, filter) {
    const { data } = await kpisServices.produtosMaisVendidosTop(filter)
    commit('SET_OBJECT', { name: 'produtosMaisVendidosTop', data, state })
  },
  async produtosMenosVendidosTop({ state, commit }, filter) {
    const { data } = await kpisServices.produtosMenosVendidosTop(filter)
    commit('SET_OBJECT', { name: 'produtosMenosVendidosTop', data, state })
  },
  async totaisFaturamentoProdutos({ state, commit }, filter) {
    const { data } = await kpisServices.totaisFaturamentoProdutos(filter)
    commit('SET_OBJECT', { name: 'totaisFaturamentoProdutos', data, state })
  },
  async totaisFaturamentoProdutosTop({ state, commit }, filter) {
    const { data } = await kpisServices.totaisFaturamentoProdutosTop(filter)
    commit('SET_OBJECT', { name: 'totaisFaturamentoProdutosTop', data, state })
  },
  async produtosMaisFaturadosTop({ state, commit }, filter) {
    const { data } = await kpisServices.produtosMaisFaturadosTop(filter)
    commit('SET_OBJECT', { name: 'produtosMaisFaturadosTop', data: assertArray(data), state })
  },
  async produtosMenosFaturadosTop({ state, commit }, filter) {
    const { data } = await kpisServices.produtosMenosFaturadosTop(filter)
    commit('SET_OBJECT', { name: 'produtosMenosFaturadosTop', data, state })
  },
  async totaisCuponsProdutos({ state, commit }, filter) {
    const { data } = await kpisServices.totaisCuponsProdutos(filter)
    commit('SET_OBJECT', { name: 'totaisCuponsProdutos', data, state })
  },
  async totaisCuponsProdutosTop({ state, commit }, filter) {
    const { data } = await kpisServices.totaisCuponsProdutosTop(filter)
    commit('SET_OBJECT', { name: 'totaisCuponsProdutosTop', data, state })
  },
  async produtosMaisCuponsTop({ state, commit }, filter) {
    const { data } = await kpisServices.produtosMaisCuponsTop(filter)
    commit('SET_OBJECT', { name: 'produtosMaisCuponsTop', data, state })
  },
  async produtosMenosCuponsTop({ state, commit }, filter) {
    const { data } = await kpisServices.produtosMenosCuponsTop(filter)
    commit('SET_OBJECT', { name: 'produtosMenosCuponsTop', data, state })
  },

  async totaisClientesProdutos({ state, commit }, filter) {
    const { data } = await kpisServices.totaisClientesProdutos(filter)
    commit('SET_OBJECT', { name: 'totaisClientesProdutos', data, state })
  },
  async totaisClientesProdutosTop({ state, commit }, filter) {
    const { data } = await kpisServices.totaisClientesProdutosTop(filter)
    commit('SET_OBJECT', { name: 'totaisClientesProdutosTop', data, state })
  },
  async produtosMaisClientesTop({ state, commit }, filter) {
    const { data } = await kpisServices.produtosMaisClientesTop(filter)
    commit('SET_OBJECT', { name: 'produtosMaisClientesTop', data, state })
  },
  async produtosMenosClientesTop({ state, commit }, filter) {
    const { data } = await kpisServices.produtosMenosClientesTop(filter)
    commit('SET_OBJECT', { name: 'produtosMenosClientesTop', data, state })
  },
  async precoMedio({ state, commit }, filter) {
    const { data } = await kpisServices.precoMedio(filter)
    commit('SET_OBJECT', { name: 'precoMedio', data, state })
  },
  async mediaItens({ state, commit }, filter) {
    const { data } = await kpisServices.mediaItens(filter)
    commit('SET_OBJECT', { name: 'mediaItens', data, state })
  },
  async quantidadeCesta({ state, commit }, filter) {
    const { data } = await kpisServices.quantidadeCesta(filter)
    commit('SET_OBJECT', { name: 'quantidadeCesta', data, state })
  },
  async horasMaioresCompras({ state, commit }, filter) {
    const { data } = await kpisServices.horasMaioresCompras(filter)
    commit('SET_OBJECT', { name: 'horasMaioresCompras', data, state })
  },
  async diasMaioresCompras({ state, commit }, filter) {
    const { data } = await kpisServices.diasMaioresCompras(filter)
    commit('SET_OBJECT', { name: 'diasMaioresCompras', data, state })
  },
  async diasSemanaMaioresCompras({ state, commit }, filter) {
    const { data } = await kpisServices.diasSemanaMaioresCompras(filter)
    commit('SET_OBJECT', { name: 'diasSemanaMaioresCompras', data, state })
  },
  async magicPricePoint({ state, commit }, filter) {
    const { data } = await kpisServices.magicPricePoint(filter)
    commit('SET_OBJECT', { name: 'mpp', data, state })
  },
  async productsTree({ state, commit }, params) {
    const data = await productsServices.productsTree(params)
    const object = { children: data }
    commit('SET_OBJECT', { name: 'productsTree', data: object, state })
  },
  async categoriesTree({ state, commit }, params) {
    const data = await productsServices.categoriesTree(params)
    const object = { children: data }
    commit('SET_OBJECT', { name: 'categoriesTree', data: object, state })
  },
  async searchList({ state }, idList) {
    const data = await productsServices.searchProductList(idList)
    return data
  },
  async searchCategoriesList({ state }, idList) {
    const data = await categoriesService.searchList(idList)
    return data
  },

  async searchCategories({ state }, search) {
    const data = await categoriesService.searchCategories(search.categoria_produto)
    return data
  },

  async productComparisons({ state }, filters) {
    const data = await productsServices.productComparisons(filters)
    return data
  },

  async categoryComparisons({ state }, filters) {
    const data = await productsServices.categoryComparisons(filters)
    return data
  },

  async getMeasuresUnits({ commit }) {
    const measures = await apolloProvider.defaultClient
      .query({
        query: QUERY_GET_MEASURES,
        variables: {
          page: 1,
          pageSize: 100,
        },
        fetchPolicy: 'no-cache',
      })
      .then(({ data: listMeasure }) => {
        return listMeasure.listMeasure.measures.map((measure) => {
          return {
            ...measure,
            measureAcronym: getMeasureUnit(measure.acronym),
          }
        })
      })
    commit('SET_MEASURES_UNITS', measures)
  },
}
